import * as z from "zod/v4";

export const PoshmarkListingSchema_ = z.object({
  channel: z.literal("POSHMARK"),
  id: z.string(),
  productId: z.string(),
  catalogId: z.string().nullable(),
  sku: z.string().nullable(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  department: z.string().nullable(),
  category: z.string().nullable(),
  condition: z.string().nullable(),
  imageUrls: z.array(z.string()).nullable(),
  brand: z.string().nullable(),
  color1: z.string().nullable(),
  color2: z.string().nullable(),
  styleTags: z.array(z.string()).nullable(),
  originalPrice: z.number().nullable(),
  listingPrice: z.number().nullable(),
  availability: z.string().nullable(),
  quantity: z.number().nullable(),
  size: z.string().nullable(),
  variantGroupId: z.string().nullable(),
  variantType: z.string().nullable(),
  variantAttribute: z.string().nullable(),
  upc: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const PoshmarkListingSchema: z.ZodType<PoshmarkListing> =
  PoshmarkListingSchema_;
export interface PoshmarkListing
  extends z.infer<typeof PoshmarkListingSchema_> {}
